<template>
  <div class="org-search-create-application-button">
    <NrToolip
      :label="
        !orgIdPresent
          ? 'Please enter the organization ID before creating an application.'
          : appIdPresent
          ? 'An application already exists for this organization.'
          : ''
      "
    >
      <NrButton
        type="button"
        variant="filled-primary"
        @click="createApplication"
        :disabled="!orgIdPresent || appIdPresent"
        >Create application in the org</NrButton
      >
    </NrToolip>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, onMounted, ref } from 'vue'
import NrButton from '@nextrequestco/components/src/components/NrButton'
import NrToolip from '@nextrequestco/components/src/components/NrTooltip'
import API from '../../../vue_shared/api.js'
import { useToasted } from 'src/utils/vue-toasted/inject_toasted'

const props = defineProps({
  accountId: {
    type: String,
    required: true
  }
})

const orgIdPresent = ref(false)
const appIdPresent = ref(false)

const toasted = useToasted()

onMounted(() => {
  orgIdPresent.value = !!(
    document.getElementById(
      `cp-account-organization-id-${props.accountId}`
    ) as HTMLInputElement
  )?.value
  appIdPresent.value = !!(
    document.getElementById(
      `cp-application-id-${props.accountId}`
    ) as HTMLInputElement
  )?.value
})

const createApplication = () => {
  API.ensureCivicPlusApplicationExists(props.accountId)
    .then((response) => {
      const applicationId = response.data.cp_application_id
      toasted.success('CivicPlus application created successfully.')
      const textField = document.getElementById(
        `cp-application-id-${props.accountId}`
      )
      textField.value = applicationId
      appIdPresent.value = true
    })
    .catch(() => {
      toasted.error(
        'An error occurred while creating the CivicPlus application.'
      )
    })
}
</script>
<style scoped lang="scss">
.org-search-create-application-button {
  // Overrides the default disabled button styles to ensure the text is visible
  button[disabled]:hover {
    color: #fff;
  }
}
</style>
